import { IoClose } from "react-icons/io5"
import CustomModal from "../../../component/modal/CustomModal"
import { Button } from "../../../component/form"
import ButtonLoader from "../../../component/buttonLoader"

const OtherPlanDetails = ({ show, close, isLoading, onConfirm, data }) => {
    console.log({ data });

    return (
        <CustomModal
            show={show}
            className={"logoutModal wrapper_plans_subscription overwrite_plans_subscription"}
            closeButton={false}
        >
            <span className="close_button"
                onClick={() => close()}
            >
                <IoClose />
            </span>

            <div className="wrap_log_modal">
                <p className="heading_p">{data?.userSubscription ? "Active Plan Exhausted" : "Active Plan with Remaining Consultations"}</p>
                <ul>
                    <p>{data?.userSubscription ? `You’ve used all consultations under your active plan. You can now repurchase the same or choose a different plan` : "  You already have an active plan with remaining consultations. Please use them before buying a new plan"}?</p>
                    {/* <p>You already have an active health plan.
                        You cannot purchase a new plan until your current one expires.</p> */}
                </ul>
                <div className="button_wrap">
                    <Button className='text-center' onClick={() => close()}>No</Button>
                    <ButtonLoader
                        className="button cstm_buy_now ActivePlan"
                        isLoading={isLoading}
                        onClick={onConfirm}
                        text="Yes"
                    />
                </div>
            </div>
        </CustomModal>
    )
}

export default OtherPlanDetails